import { render, staticRenderFns } from "./SiteTreePageItem.vue?vue&type=template&id=b1b3da48&scoped=true"
import script from "./SiteTreePageItem.vue?vue&type=script&lang=js"
export * from "./SiteTreePageItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b3da48",
  null
  
)

export default component.exports